import { List, Record } from 'immutable';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import * as DeliveryMethodTypes from 'automation-ui-action-features/actions/in-app-notification/DeliveryMethodTypes';
import * as InAppNotificationActionMetadataKeys from 'automation-ui-action-features/actions/in-app-notification/InAppNotificationActionMetadataKeys';
export default class InAppNotificationActionMetadata extends Record({
  [InAppNotificationActionMetadataKeys.ACTION_TYPE]: ActionTypes.IN_APP_NOTIFICATION,
  [InAppNotificationActionMetadataKeys.DELIVERY_METHOD]: DeliveryMethodTypes.APP,
  [InAppNotificationActionMetadataKeys.SUBJECT]: null,
  [InAppNotificationActionMetadataKeys.BODY]: null,
  [InAppNotificationActionMetadataKeys.TEAM_IDS]: null,
  [InAppNotificationActionMetadataKeys.USER_IDS]: null,
  [InAppNotificationActionMetadataKeys.OWNER_PROPERTIES]: null
  // To be supported in future version
  // [EmailNotificationActionMetadataKeys.OWNER_IDS]: null,
}, 'InAppNotificationActionMetadata') {
  getDeliveryMethod() {
    return this[InAppNotificationActionMetadataKeys.DELIVERY_METHOD];
  }
  getTeamIds() {
    const teamIds = this.get(InAppNotificationActionMetadataKeys.TEAM_IDS);
    return teamIds !== null ? List(teamIds) : List();
  }
  getUserIds() {
    const userIdsValue = this.get(InAppNotificationActionMetadataKeys.USER_IDS);
    const userIds = userIdsValue !== null ? List(userIdsValue) : List();
    return userIds.map(userId => `${userId}`);
  }
  getOwnerProperties() {
    const ownerProperties = this.get(InAppNotificationActionMetadataKeys.OWNER_PROPERTIES);
    return ownerProperties !== null ? List(ownerProperties) : List();
  }
}